import axios from "axios";

const moduleUnitMaster = {
  namespaced: true,
  state: {
    unitList: [],
    createUnitItem: null,
  },
  mutations: {
    setUnitList(state, data) {
      state.unitList = data;
    },
  },
  actions: {
    async fetchUnitList({ commit }, { clinicUrl, branchUrl }) {
      try {
        const res = await axios.get(
          `/api/master/muom/${clinicUrl}/${branchUrl}`
        );
        const items = res.data.data.map(i => ({
          unitId: i.id,
          unitCode: i.code,
          unitNameTh: i.description,
          unitNameEn: i.description2,
          unitStatus: i.status,
          creationDt: i.creationDt,
        }));
        commit("setUnitList", items);
        return items;
      } catch (err) {
        console.error("fetchUnitList failed", err);
        throw err;
      }
    },
    createUnitItem({ commit, getters }, payload) {
      return axios
        .post(
          `/api/master/mUom/${payload.clinicUrl}/${payload.branchUrl}`,
          payload.adjustUnitItem,
          {
            skipGlobalErrorHandler: true,
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          throw err;
        });
    },

    updateUnitItem({ commit, getters }, payload) {
      return axios
        .put(
          `/api/master/mUom/${payload.clinicUrl}/${payload.branchUrl}/${payload.id}`,
          payload.adjustUnitItem,
          {
            skipGlobalErrorHandler: true,
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          throw err;
        });
    },

    deleteUnitItem({ commit, getters }, payload) {
      return axios
        .delete(
          `/api/master/mUom/${payload.clinicUrl}/${payload.branchUrl}/${payload.id}`,
          {
            skipGlobalErrorHandler: true,
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          throw err;
        });
    },
  },
  getters: {
    getUnitList: state => {
      return state.unitList;
    },
  },
};

export default moduleUnitMaster;
